import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface CompanyConfigUrls {
    readonly general: string;
    readonly users: string;
    readonly license: string;
    readonly ordersLab: string;
}

interface CompanyConfigInternalItem {
    readonly manageCompanyLicensesUrl: string;
    readonly manageCompanyUrl: string;
    readonly manageCompanyUsersUrl: string;
    readonly manageMyCompanyOrdersLab: string;
}

export class CompanyConfigUrlsQuery extends Query<CompanyConfigUrls> { }

export class CompanyConfigUrlsQueryHandlerBase implements QueryHandler<CompanyConfigUrlsQuery, CompanyConfigUrls> {
    private static Url = TaggedUrl.join('myCompany/managementLinks', [Tags.Api, Tags.NotHandle5xx]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(): Promise<CompanyConfigUrls> {
        const { data } = await this.http.get<CompanyConfigInternalItem>(CompanyConfigUrlsQueryHandlerBase.Url);
        return {
            general: data.manageCompanyUrl,
            users: data.manageCompanyUsersUrl,
            license: data.manageCompanyLicensesUrl,
            ordersLab: data.manageMyCompanyOrdersLab
        };
    }
}
